module.exports = __webpack_public_path__ + "img/hsw.0a911d25.png";